// extracted by mini-css-extract-plugin
module.exports = {"tagLine":"TagLine_tagLine__TvX3H","wrapper":"TagLine_wrapper__nSQwS","tagLabel":"TagLine_tagLabel__gqiyB","tagIcon":"TagLine_tagIcon__tQZgu"};